import React from 'react';

const StarIcon = props => {
    const { size = 24, style = {} } = props;
    return (
        <svg
            style={{ width: size, height: size, ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="#ff8000"
            className="feather feather-star"
        >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
    );
};

export default StarIcon;
